//= require './markdown_editor'

window.EvaluatorAssignments = {
  _gridApi: null,

  _gridOptions: {
    columnDefs: null,
    rowData: null,
    rowHeight: 44,
    headerHeight: 50,
    groupDefaultExpanded: -1,
    rowSelection: 'multiple',
    treeData: true,
    animateRows: true,
    suppressRowClickSelection: true,
    suppressContextMenu: true,
    defaultColDef: {
      resizable: true
    },
    getDataPath(data) { return data.hierarchy; },
    onGridSizeChanged(_event) { return _event.api.sizeColumnsToFit(); },
    onRowSelected(event) { return EvaluatorAssignments._assignFormToAllEvaluators(event.node); }
  },

  _assignFormToAllEvaluators(rowNode) {
    const isSelected = rowNode.isSelected();

    if (this._isFormOfTenderOrSection(rowNode)) {
      this._toggleAllEvaluatorsForForm(rowNode, rowNode.isSelected());
    } else {
      const childrenNodes = rowNode.childrenAfterGroup;
      if (isSelected || _.every(childrenNodes, childNode => childNode.isSelected())) {
        _.each(childrenNodes, childNode => childNode.setSelected(isSelected));
      }
    }

    this._toggleParentNode(rowNode, isSelected);
    this._toggleHeadersChecks();
    return this._toggleSubmitBtn();
  },

  _toggleHeadersChecks() {
    const allRowsSelected = this._areAllRowsSelected();
    $('.check-all').prop('checked', allRowsSelected);
    return $('.check-all-forms-for-evaluator').prop('checked', allRowsSelected);
  },

  _toggleParentNode(rowNode, isSelected) {
    if (rowNode.parent) {
      const siblingNodes = this._siblingNodes(rowNode);
      if (isSelected && _.every(siblingNodes, node => node.isSelected())) {
        return rowNode.parent.setSelected(isSelected);
      } else if (!isSelected) {
        return rowNode.parent.setSelected(isSelected);
      }
    }
  },

  _areAllRowsSelected() {
    let allSelected = true;
    this._gridApi.forEachNode(function (node) {
      if (!node.isSelected()) { return allSelected = false; }
    });
    return allSelected;
  },

  _siblingNodes(rowNode) {
    const siblingNodes = [];
    this._gridApi.forEachNode(function (node) {
      if (rowNode.parent && node.parent && (node.id !== rowNode.id) && (node.parent.id === rowNode.parent.id)) {
        return siblingNodes.push(node);
      }
    });
    return siblingNodes;
  },

  _isFormOfTender(rowNode) {
    return rowNode.data.type === 'form_of_tender';
  },

  _isSection(rowNode) {
    return rowNode.data.type === 'evaluations_template_section';
  },

  _isFormOfTenderOrSection(rowNode) {
    return rowNode.data && rowNode.data.id;
  },

  _renderEvaluatorRow(rowNode) {
    if (this._isFormOfTenderOrSection(rowNode)) {
      const formId = rowNode.data.id;
      const evaluatorId = rowNode.column.colId;
      const {
        itemId
      } = rowNode.data;
      const {
        type
      } = rowNode.data;
      const {
        category
      } = rowNode.data;
      const isChecked = rowNode.data[evaluatorId].assigned ? 'checked' : '';

      if (this._isFormOfTender(rowNode)) {
        const {
          step
        } = rowNode.data[evaluatorId];
        return this._renderFormAssignmentStepSelectWithCheckbox(formId, type, itemId, evaluatorId, category, step, isChecked);
      } else {
        return this._renderFormAssignmentCheckbox(formId, type, itemId, evaluatorId, category, isChecked);
      }
    }
  },

  _renderFormAssignmentStepSelectWithCheckbox(formId, type, itemId, evaluatorId, category, step, isChecked) {
    return "<div>" +
      this._renderFormAssignmentCheckbox(formId, type, itemId, evaluatorId, category, isChecked) +
      `<select class='form-of-tender-evaluator-step nano select width-auto small-left-buffer inline' ${!isChecked ? 'disabled' : undefined}>` +
      _.map(_.range(1, this._evaluatorsCount + 1), function (i) {
        const selected = step === i ? 'selected' : '';
        return `<option ${selected} value='${i}'>${I18n.t('step')} ${i}</option>`;
      }).join() +
      "</select>" +
      "</div>";
  },

  _renderFormAssignmentCheckbox(formId, type, itemId, evaluatorId, category, isChecked) {
    return "<label class='custom-checkbox'>" +
      `<input type='checkbox' data-form-id='${formId}' data-document-type='${type}' data-item-id='${itemId}' data-evaluator-id='${evaluatorId}' data-category='${category}' value='1' class='assign-evaluator' ${isChecked}>` +
      "<span class='checkbox'></span>" +
      "</label>";
  },

  _checkAll(event) {
    const selected = $(event.currentTarget).prop('checked');
    this._gridApi.forEachNode(node => node.setSelected(selected));
    return $('.check-all-forms-for-evaluator').prop('checked', selected).trigger('change');
  },

  _toggleAllEvaluatorsForForm(rowNode, isSelected) {
    const $assignEvaluatorCheckboxes = $(`[data-document-type='${rowNode.data.type}'][data-form-id='${rowNode.data.id}'][data-category='${rowNode.data.category}']`);

    if (isSelected || _.all($assignEvaluatorCheckboxes, el => $(el).prop('checked'))) {
      $assignEvaluatorCheckboxes.prop('checked', isSelected);
      this._toggleFormOfTenderStepSelection(rowNode, $assignEvaluatorCheckboxes, isSelected);
      return _.each(this._evaluatorIds, function (evaluatorId) {
        const rowNodeData = rowNode.data;
        rowNodeData[evaluatorId].assigned = isSelected;
        return rowNode.setData(rowNodeData);
      });
    }
  },

  _checkAllFormsForEvaluator(event) {
    const $currentTarget = $(event.currentTarget);
    const selected = $currentTarget.prop('checked');
    const evaluatorId = $currentTarget.data('evaluatorId');
    const $evaluatorCheckboxes = $(`.assign-evaluator[data-evaluator-id='${evaluatorId}']`);
    $evaluatorCheckboxes.prop('checked', selected).trigger('change');

    return this._gridApi.forEachNode(rowNode => {
      if (this._isFormOfTenderOrSection(rowNode)) {
        this._toggleFormOfTenderStepSelection(rowNode, $evaluatorCheckboxes, selected);
        const rowNodeData = rowNode.data;
        rowNodeData[evaluatorId].assigned = selected;
        return rowNode.setData(rowNodeData);
      }
    });
  },

  _toggleFormOfTenderStepSelection(rowNode, $assignEvaluatorCheckboxes, enabled) {
    if (this._isFormOfTender(rowNode)) {
      const select = $assignEvaluatorCheckboxes.closest('div').find('select');
      if (enabled) {
        return $(select).removeAttr('disabled');
      } else {
        return $(select).attr('disabled', 'disabled');
      }
    }
  },

  _updateAssignedEvaluatorStep(event) {
    const $currentTarget = $(event.currentTarget);
    $currentTarget.removeAttr('disabled');
    const $assignedEvaluatorCheckbox = $currentTarget.closest('div').find('input[type="checkbox"]');
    const evaluatorId = $assignedEvaluatorCheckbox.data('evaluatorId');
    const category = $assignedEvaluatorCheckbox.data('category');
    return this._gridApi.forEachNode(rowNode => {
      if (this._isFormOfTender(rowNode) && (rowNode.data.category === category)) {
        const rowNodeData = rowNode.data;
        rowNodeData[evaluatorId].step = Number($currentTarget.val());
        return rowNode.setData(rowNodeData);
      }
    });
  },

  _initializeEmptyAssignEvaluatorsDataStruct() {
    const dataStruct = { evaluator_assignments: {} };
    _.each(this._categories, category => dataStruct['evaluator_assignments'][`${category}`] = {
      form_of_tender: { assigned_evaluators: [] },
      evaluations_template_sections: []
    });
    return dataStruct;
  },

  _assignedEvaluatorsWithStepsToFormOfTender(rowNode) {
    const assignedEvaluators = [];
    _.each(this._evaluatorIds, function (evaluatorId) { if (rowNode.data[evaluatorId].assigned) { return assignedEvaluators.push({ id: `${evaluatorId}`, step: rowNode.data[evaluatorId].step }); } });
    return assignedEvaluators;
  },

  _assignedEvaluatorsToBidEvaluationSection(rowNode) {
    const assignedEvaluators = [];
    _.each(this._evaluatorIds, function (evaluatorId) { if (rowNode.data[evaluatorId].assigned) { return assignedEvaluators.push({ id: evaluatorId }); } });
    return assignedEvaluators;
  },

  _saveAssignedEvaluators(event) {
    const $target = $(event.currentTarget);
    const disableWith = $target.data('disableWith');
    $target.prop('disabled', true).val(disableWith);
    event.preventDefault();

    const data = this._initializeEmptyAssignEvaluatorsDataStruct();

    this._gridApi.forEachNode(rowNode => {
      if (this._isFormOfTenderOrSection(rowNode)) {
        if (this._isFormOfTender(rowNode)) {
          data['evaluator_assignments'][rowNode.data.category][rowNode.data.type]['id'] = rowNode.data.id;
          return data['evaluator_assignments'][rowNode.data.category][rowNode.data.type]['assigned_evaluators'] = this._assignedEvaluatorsWithStepsToFormOfTender(rowNode);
        } else if (this._isSection(rowNode)) {
          return data['evaluator_assignments'][rowNode.data.category][rowNode.data.type + 's'].push({ id: rowNode.data.id, assigned_evaluators: this._assignedEvaluatorsToBidEvaluationSection(rowNode) });
        }
      }
    });

    const url = $('#evaluator-assignments-form').attr('action');
    data['evaluator_assignments']['evaluators_note'] = MarkdownEditor.editor.value();
    data["authenticity_token"] = $('meta[name=csrf-token]').attr('content');
    data['evaluator_assignments_templates_id'] = $('#evaluator_assignments_templates').val();

    return $.ajax({
      url,
      data: JSON.stringify(data),
      contentType: "application/json",
      dataType: 'json',
      method: 'POST',
      success(response) {
        return window.location.href = response.redirect_to;
      },
      error() {
        return window.location.reload();
      }
    });
  },

  _checkHeadersCheckboxes(event) {
    const $currentTarget = $(event.currentTarget);
    const evaluatorId = $currentTarget.data('evaluatorId');
    const selected = $currentTarget.prop('checked');
    const $evaluatorDocuments = $(`.assign-evaluator[data-evaluator-id=${evaluatorId}]`);
    const $evaluatorHeader = $(`.check-all-forms-for-evaluator[data-evaluator-id=${evaluatorId}]`);
    $evaluatorHeader.prop('checked', _.every($evaluatorDocuments, document => $(document).prop('checked')));
    const $checkAllHeader = $('.check-all');
    const $allEvaluatorHeaders = $('.check-all-forms-for-evaluator');
    $checkAllHeader.prop('checked', _.every($allEvaluatorHeaders, header => $(header).prop('checked')));
    const formId = $currentTarget.data('formId');
    const category = $currentTarget.data('category');

    this._gridApi.forEachNode(rowNode => {
      if (rowNode.data) {
        if (this._isFormOfTenderOrSection(rowNode) && (rowNode.data.category === category) && (rowNode.data.id === formId)) {
          const $assignEvaluatorCheckboxes = $(`[data-document-type='${rowNode.data.type}'][data-form-id='${rowNode.data.id}'][data-category='${rowNode.data.category}']`);
          rowNode.setSelected(_.all($assignEvaluatorCheckboxes, el => $(el).prop('checked')));
          this._toggleFormOfTenderStepSelection(rowNode, $currentTarget, selected);
          const rowNodeData = rowNode.data;
          rowNodeData[evaluatorId].assigned = selected;
          return rowNode.setData(rowNodeData);
        }
      }
    });
    return this._toggleSubmitBtn();
  },

  _categoryHeaderRowExists(category) {
    return _.any(this._gridApi.getModel().rowsToDisplay, node => (node.data.hierarchy.length === 1) && (node.data.hierarchy[0] === category));
  },

  _subcategoryHeaderRowExists(category, subcategory) {
    return _.any(this._gridApi.getModel().rowsToDisplay, node => (node.data.hierarchy.length === 2) && (node.data.hierarchy[0] === category) && (node.data.hierarchy[1] === subcategory));
  },

  _changeBidEvaluationTemplate(event) {
    const $currentTarget = $(event.currentTarget);
    const templateId = parseInt($currentTarget.val());
    return this._selectBidEvaluationTemplate(templateId);
  },

  _selectBidEvaluationTemplate(templateId) {
    const nodesToBeRemoved = [];
    this._gridApi.forEachNode(rowNode => {
      const leafNodes = _.reject(rowNode.allLeafChildren, node => node.allChildrenCount !== null);
      if (this._isSection(rowNode) || ((leafNodes.length > 0) && _.every(_.map(leafNodes, leafNode => this._isSection(leafNode))))) {
        return nodesToBeRemoved.push(rowNode.data);
      }
    });
    this._gridApi.applyTransaction({ remove: nodesToBeRemoved });

    const selectedTemplate = _.where(this._evaluationsFormData.bid_evaluation_templates, { id: templateId })[0];
    if (selectedTemplate) {
      const newNodes = [];
      _.each(selectedTemplate.categories, category => {
        const subcategory = category.sections[0].hierarchy[1];
        if (!this._categoryHeaderRowExists(category.name)) {
          newNodes.push({ title: I18n.t(`v4.evaluator_assignments.categories.${category.name}`), category: category.name, hierarchy: [category.name] });
        }
        if (!this._subcategoryHeaderRowExists(category.name, subcategory)) {
          newNodes.push({ title: I18n.t(`v4.evaluator_assignments.subcategories.${subcategory}`), category: subcategory, hierarchy: [category.name, subcategory] });
        }

        return newNodes.push(category.sections);
      });
      this._gridApi.applyTransaction({ add: _.flatten(newNodes) });
    }

    return resizeAgGridTable(this._tableSelector, this._gridOptions, 0, false, false, 20);
  },

  _categoriesGroupRows() {
    return _.map(this._categories, category => ({
      title: I18n.t(`v4.evaluator_assignments.categories.${category}`),
      hierarchy: [category]
    }));
  },

  _buildRowData() {
    const data = [];
    _.each(this._bidderDocumentsData.categories, function (category) {
      const subcategory = category.form_of_tender.hierarchy[1];
      data.push({ title: I18n.t(`v4.evaluator_assignments.categories.${category.name}`), category: category.name, hierarchy: [category.name] });
      data.push({ title: I18n.t(`v4.evaluator_assignments.subcategories.${subcategory}`), category: subcategory, hierarchy: [category.name, subcategory] });
      return data.push(category.form_of_tender);
    });
    return _.flatten(data);
  },

  _toggleSubmitBtn() {
    return $('#evaluator-assignments-form input[type="submit"]').toggleClass('disabled', $('.assign-evaluator:checked').length === 0);
  },

  _markSelectedBidEvaluationSections() {
    if (_.isEmpty(this._bidEvaluationSections)) { return; }
  },

  initializeTable(tableSelector, data, key) {
    const {
      evaluators
    } = data;
    this._evaluationsFormData = data.evaluations_form_data;
    this._bidderDocumentsData = data.bidder_documents_data;
    this._bidEvaluationSections = data.bid_evaluation_sections;

    this._evaluatorsCount = evaluators.length;
    this._evaluatorIds = _.map(evaluators, evaluator => evaluator.id);
    this._categories = data.categories;
    this._bid_evaluation_question_categories = data.bid_evaluation_question_categories;
    this._tender_evaluation_question_categories = data.tender_evaluation_question_categories;
    this._tableSelector = `#${tableSelector}`;

    const rowData = this._buildRowData();

    agGrid.LicenseManager.setLicenseKey(key);
    suppressLicenseErrorForTestEnvironment();

    const gridDiv = document.getElementById(tableSelector);
    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;

    const HeaderWithCheckboxComponent = function () { };

    HeaderWithCheckboxComponent.prototype.init = function (params) {
      const eTemp = document.createElement('div');
      eTemp.innerHTML = this.getTemplate(params);
      this.eGui = eTemp.firstElementChild;
    };

    HeaderWithCheckboxComponent.prototype.getTemplate = function (params) {
      if (params.evaluatorId) {
        return "<label class='custom-checkbox inverted-checkbox bold'>" +
          `<input class='check-all-forms-for-evaluator' data-evaluator-id=${params.evaluatorId} type='checkbox'>` +
          "<span class='checkbox left'></span>" +
          "<span class='label'>" +
          `<label class="small-text">${params.displayName}</label>` +
          `<span class="super-small-text">${params.reviewsCount} ` +
          I18n.t('v4.document_set_reviews.assigned_reviews') +
          "</span>" +
          "</span>" +
          "</label>";
      } else {
        return "<label class='custom-checkbox inverted-checkbox bold'>" +
          "<input class='check-all' type='checkbox'>" +
          "<span class='checkbox'></span>" +
          `<label class="small-text">${params.displayName}</label>` +
          "</label>";
      }
    };

    HeaderWithCheckboxComponent.prototype.getGui = function () {
      return this.eGui;
    };

    HeaderWithCheckboxComponent.prototype.destroy = function () { };

    const evaluatorColumns = _.map(evaluators, evaluator => {
      return {
        headerName: evaluator.name,
        field: `${evaluator.id}`,
        headerComponent: HeaderWithCheckboxComponent,
        headerComponentParams: { evaluatorId: evaluator.id, reviewsCount: evaluator.reviews_count },
        minWidth: 200,
        cellRenderer: rowData => this._renderEvaluatorRow(rowData)
      };
    });

    this._gridOptions.autoGroupColumnDef = {
      headerName: I18n.t('v4.document_set_reviews.check_all'),
      headerComponent: HeaderWithCheckboxComponent,
      field: 'title',
      width: 300,
      pinned: 'left',
      suppressSizeToFit: true,
      checkboxSelection: true,
      cellRendererParams: {
        suppressCount: true,
        supressPadding: true,
        innerRenderer(params) { return params.data.title; }
      }
    };

    this._gridApi.setGridOption('columnDefs', evaluatorColumns);
    this._gridApi.setGridOption('rowData', rowData);
    resizeAgGridTable(this._tableSelector, this._gridOptions, 0, false, false, 20);
    this._gridApi.sizeColumnsToFit();

    const editor = MarkdownEditor.initialize('#evaluator_assigment_evaluators_note');
    if (data.evaluators_note) { editor.value(data.evaluators_note); }

    editor.codemirror.on('change', this._toggleSubmitBtn);

    $(document).on('change', '.check-all', _.bind(this._checkAll, this));
    $(document).on('change', '.assign-evaluator', _.bind(this._checkHeadersCheckboxes, this));
    $(document).on('change', '.check-all-forms-for-evaluator', _.bind(this._checkAllFormsForEvaluator, this));
    $(document).on('click', 'input[type="submit"]', _.bind(this._saveAssignedEvaluators, this));
    $(document).on('change', '.form-of-tender-evaluator-step', _.bind(this._updateAssignedEvaluatorStep, this));
    $(document).on('change', '#evaluator_assignments_templates', _.bind(this._changeBidEvaluationTemplate, this));

    if (data.selected_bid_template_id) {
      this._selectBidEvaluationTemplate(data.selected_bid_template_id);
    }
  }
};
